export default function CDereference() {
  return <h2>C Dereference</h2>;
}
